import { Navbar, Nav, Container } from 'react-bootstrap';
//import '../data/Navbar.css';
import { useTheme, DARK, LIGHT } from '../context/ThemeContext';
import { BrowserRouter as Router } from "react-router-dom";
import { useState, useEffect } from 'react';

export const NavBar = () => {

    const { isDark, toggleTheme } = useTheme();
    const t = isDark ? DARK : LIGHT;
    

    const [activeLink, setActiveLink] = useState('home');
    const [isOpen, setIsOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 50);
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
      }, []);
    
      const navLinks = ['Home', 'About', 'Skills', 'Experience', 'Education', 'Projects', 'Blogs', 'Contact'];
    
      const s = {
        nav: {
          background: scrolled
            ? isDark ? 'rgba(22,27,34,0.97)' : 'rgba(255,255,255,0.97)'
            : t.navBg,
          backdropFilter: 'blur(12px)',
          borderBottom: `1px solid ${t.border}`,
          padding: scrolled ? '10px 32px' : '16px 32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 9999,
          transition: 'all 0.3s ease',
          boxShadow: scrolled ? t.shadow : 'none',
          boxSizing: 'border-box',
        },
        brand: {
          fontWeight: 700,
          fontSize: '17px',
          color: t.text,
          letterSpacing: '0.5px',
          textDecoration: 'none',
        },
        linkRow: {
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          flexWrap: 'wrap',
        },
        link: (name) => ({
          fontSize: '13px',
          fontWeight: activeLink === name.toLowerCase() ? 600 : 500,
          color: activeLink === name.toLowerCase() ? t.accent : t.textSub,
          padding: '6px 12px',
          borderRadius: '6px',
          textDecoration: 'none',
          background: activeLink === name.toLowerCase() ? t.tagBg : 'transparent',
          transition: 'all 0.15s',
          cursor: 'pointer',
          border: 'none',
          display: 'inline-block',
        }),
        toggleBtn: {
          background: t.toggleBg,
          border: `1px solid ${t.border}`,
          color: t.text,
          borderRadius: '20px',
          padding: '5px 14px',
          fontSize: '12px',
          fontWeight: 600,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          marginLeft: '12px',
          transition: 'all 0.2s',
          whiteSpace: 'nowrap',
        },
      };
    
      return (
        <nav style={s.nav}>
          <a href="#home" style={s.brand}>Sandhya</a>
          <div style={s.linkRow}>
            {navLinks.map((name) => (
              <a
                key={name}
                href={`#${name.toLowerCase()}`}
                style={s.link(name)}
                onClick={() => setActiveLink(name.toLowerCase())}
                onMouseEnter={e => {
                  if (activeLink !== name.toLowerCase()) {
                    e.currentTarget.style.color = t.accent;
                    e.currentTarget.style.background = t.tagBg;
                  }
                }}
                onMouseLeave={e => {
                  if (activeLink !== name.toLowerCase()) {
                    e.currentTarget.style.color = t.textSub;
                    e.currentTarget.style.background = 'transparent';
                  }
                }}
              >
                {name}
              </a>
            ))}
            <button style={s.toggleBtn} onClick={toggleTheme}>
              {t.toggleIcon} {t.toggleLabel}
            </button>
          </div>
        </nav>
      );
    };